import React, { useEffect, useRef, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col,
} from "reactstrap";
import { showToast } from "components/Common";
import StatisticService from "services/Statistic";
import TableDetail from "./TableDetail";
import FilterDetail from "./FilterDetail";
import { DELAY_FETCH } from "constant";
import { scrollToTopRow } from "components/Common/Table";
import { startOfMonth, format } from "date-fns";
const Index = ({ isOpen, onClose, param, filter, filterAll }) => {
  const timerRef = useRef(null);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [paging, setPaging] = useState({
    currentPage: 1,
    pageSize: 100,
  });
  const getRequestParams = (params = {}, requestBody = {}) => {
    const reqParams = {
      params: {
        siteCode: param.siteCode,
        year: param.year,
        page: paging.currentPage,
        size: paging.pageSize,
        ...params,
      },
      requestBody: {
        dateFrom: format(startOfMonth(filterAll.dateFrom), "yyyy-MM-dd"),
        dateTo: format(startOfMonth(filterAll.dateTo), "yyyy-MM-dd"),
        ...requestBody,
      },
    };
    return reqParams;
  };
  const getTableData = (_params = {}, _requestBody = {}) => {
    const { params, requestBody } = getRequestParams(_params, _requestBody);
    setTableData(null);
    setLoading(true);

    timerRef.current = setTimeout(async () => {
      const res =
        await StatisticService.GetListDetailCombineStatMonthlyResultSaleByYearService(
          params,
          requestBody
        );

      if (res.error) {
        showToast(`${res.error.title}: ${res.error.description}`, 3);
        setTableData([]);
        setLoading(false);
        return;
      }
      setTableData(res);
      setLoading(false);
      scrollToTopRow();
    }, DELAY_FETCH);
  };

  useEffect(() => {
    if (!tableData) return;
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
  }, [tableData]);

  useEffect(() => {
    getTableData();
  }, [paging]);

  return (
    <Modal
      isOpen={isOpen}
      style={{
        width: "100%",
        maxWidth: "1600px",
        height: "100%",
        // maxHeight: "1000px",
      }}
    >
      <ModalHeader>
        Thống kê doanh số bệnh viện {param.siteCode} - {param.siteName} năm{" "}
        {param.year}
      </ModalHeader>
      <ModalBody>
        <TableDetail
          paging={paging}
          pageSize={paging.pageSize}
          setPaging={setPaging}
          data={tableData}
        />
      </ModalBody>
      <ModalFooter>
        <Button color="danger" onClick={onClose}>
          Đóng
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default Index;
